// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-1f08ddcb]{text-align:center}.title-label[data-v-1f08ddcb]{font-size:20px;line-height:1.375;margin-bottom:20px;margin-left:5px}.radio-padding[data-v-1f08ddcb]{padding-left:28%}@media screen and (max-width:768px){.radio-padding[data-v-1f08ddcb]{padding-left:12%}.title-label[data-v-1f08ddcb]{font-size:16px}}", ""]);
// Exports
module.exports = exports;
